import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { items } from '../../constants/content';
import './search.css';
import SearchResults from './searchResults';

const Search: React.SFC = () => {
    let foundItems: Array<any>;
    const [searchTimeout, setSearchTimeout] = React.useState<any>();;
    const [searchRes, setSearchRes] = React.useState<Array<any>>([]);

    const searchItemArray = (itemArray: Array<any>, searchText: string, itemHeirarchy: Array<any>) => {
        itemArray.forEach(e=>{
            if(e.caption.toLowerCase().indexOf(searchText.toLowerCase())>=0) {
                foundItems.push([...itemHeirarchy, getItemToPush(e)]);
            }
            if(e.subItems) {
                searchItemArray(e.subItems, searchText, [...itemHeirarchy, getItemToPush(e)])
            }
        })
    }

    const getItemToPush = (item : any) => {
        return {caption: item.caption, id: item.id};
    }

    const searchItems = (e: any)=>{
        foundItems = [];
        setSearchRes([]);
        if(searchTimeout) {
            clearTimeout(searchTimeout);
        }
        setSearchTimeout(setTimeout(()=>{
            if(e.target.value) {
                searchItemArray(items, e.target.value, []);
            }
            setSearchRes([...foundItems]);
        }, 600));
    }

    const searchResultClicked = () => {
        const searchEle:any = document.getElementById('search');
        if(searchEle) {
            searchEle.value = '';
        }
        setSearchRes([]);
    }

    return ( <>
    <Row>
        <Col xs={12} >
            <div className="search-container">
                <input type="text" id="search" name="search" placeholder="Search" className="search-text col-12" onChange={searchItems} />
                {searchRes.length >0 && <div className="search-results">
                    {searchRes.map((ele: Array<any>, index: number)=>{
                        return <SearchResults itemClicked={searchResultClicked} resultItem={ele} key={index}/>
                    })}
                </div>}
            </div>
        </Col>
    </Row>
    </> );
}

export default Search; 


// WEBPACK FOOTER //
// ./src/components/search/search.tsx